const a = "$$material";
export {
  a as default
};
